
/*import DMB1 from '../assets/images/thumbnails/EP1.jpg'
import DMB2 from '../assets/images/thumbnails/EP2.jpg'
import DMB3 from '../assets/images/thumbnails/EP3.jpg'
import DMB4 from '../assets/images/thumbnails/EP4.jpg'
import DMB5 from '../assets/images/thumbnails/EP5.jpg'
import DMB6 from '../assets/images/thumbnails/EP6.jpg'
import DMB7 from '../assets/images/thumbnails/EP7.jpg'
import DMB8 from '../assets/images/thumbnails/EP8.jpg'
import DMB85 from '../assets/images/thumbnails/EP8.5.png'
import DMB105 from '../assets/images/thumbnails/EP10.5.jpg'
import DMB9 from '../assets/images/thumbnails/EP9.jpg'
import DMB10 from '../assets/images/thumbnails/EP10.jpg'
import DMB11 from '../assets/images/thumbnails/EP11.jpg'
import DMB12 from '../assets/images/thumbnails/EP12.jpg'
import DMB125 from '../assets/images/thumbnails/DMB125.png'
import DMBD from '../assets/images/thumbnails/DMBD.png'
import CADMB from '../assets/images/thumbnails/CADMB.png'
import DMBT1 from '../assets/images/thumbnails/DMBT1.PNG'
import DMBT2 from '../assets/images/thumbnails/DMBT2.png'
import DMBT3 from '../assets/images/thumbnails/DMBT3.png'
import DMBP1 from '../assets/images/preview/DMBP1.png'
import DMBP2 from '../assets/images/preview/DMBP2.png'
import DMBP3 from '../assets/images/preview/DMBP3.png'
import DMBP4 from '../assets/images/preview/DMBP4.png'
import DMBP5 from '../assets/images/preview/DMBP5.png'
import DMBP6 from '../assets/images/preview/DMBP6.png'
import DMBP7 from '../assets/images/preview/DMBP7.png'
import DMBP8 from '../assets/images/preview/DMBP8.png'
import DMBP9 from '../assets/images/preview/DMBP9.png'
import DMBP10 from '../assets/images/preview/DMBP10.png'
import DMBP11 from '../assets/images/preview/DMBP11.png'
import DMBP12 from '../assets/images/preview/DMBP12.png'
import DMBP85 from '../assets/images/preview/DMBP8.5.png'
import DMBP105 from '../assets/images/preview/DMBP10.5.png'
import DMBP125 from '../assets/images/preview/DMBP125.png'*/
import DMB13 from '../assets/images/thumbnails/EP13.png'
import DMBP13 from '../assets/images/preview/DMB13P.png'

/*import LB1 from '../assets/images/thumbnails/LB1.jpg'
import LB2 from '../assets/images/thumbnails/LB2.jpg'
import LB3 from '../assets/images/thumbnails/LB3.jpg'
import LB4 from '../assets/images/thumbnails/LB4.jpg'
import LB5 from '../assets/images/thumbnails/LB5.jpg'
import LB6 from '../assets/images/thumbnails/LB6.jpg'
import LB7 from '../assets/images/thumbnails/LB7.jpg'
import LB8 from '../assets/images/thumbnails/LB8.jpg'
import LB9 from '../assets/images/thumbnails/LB9.jpg'
import LB10 from '../assets/images/thumbnails/LB10.jpg'
import LB11 from '../assets/images/thumbnails/LB11.jpg'
import LB12 from '../assets/images/thumbnails/LB12.jpg'
import LB13 from '../assets/images/thumbnails/LB13.jpg'
import LB13A from '../assets/images/thumbnails/LB13A.png'
import LB14 from '../assets/images/thumbnails/LB14.jpg'
import LB15 from '../assets/images/thumbnails/LB15.jpg'
import LB161 from '../assets/images/thumbnails/LB16-1.jpg'
import LB162 from '../assets/images/thumbnails/LB16-2.jpg'
import LB17 from '../assets/images/thumbnails/LB17.jpg'
import LB18 from '../assets/images/thumbnails/LB18.jpg'
import LB19 from '../assets/images/thumbnails/LB19.jpg'
import LB201 from '../assets/images/thumbnails/LB20-1.jpg'
import LB202 from '../assets/images/thumbnails/LB20-2.jpg'
import LBH from '../assets/images/thumbnails/LBH.jpg'
import LBA from '../assets/images/thumbnails/LBA.jpg'
import LBN from '../assets/images/thumbnails/LBN.jpg'
import CW1 from '../assets/images/thumbnails/CW1.jpg'
import CW2 from '../assets/images/thumbnails/CW2.jpg'
import Creepys1 from '../assets/images/thumbnails/Creepy1.jpg'
import Creepys2 from '../assets/images/thumbnails/Creepy2.jpg'
import Creepys3 from '../assets/images/thumbnails/Creepy3.jpg'
import Creepys4 from '../assets/images/thumbnails/Creepy4.jpg'
import Creepys5 from '../assets/images/thumbnails/Creepy5.png'
import PD1 from '../assets/images/thumbnails/PD1.jpg'
import PD2 from '../assets/images/thumbnails/PD2.jpg'
import PD3 from '../assets/images/thumbnails/PD3.jpg'
import PD4 from '../assets/images/thumbnails/PD4.jpg'
import PD5 from '../assets/images/thumbnails/PD5.png'
import PD6 from '../assets/images/thumbnails/PD6.png'
import Jueguemos1 from '../assets/images/thumbnails/Jueguemos1.jpg'
import Jueguemos2 from '../assets/images/thumbnails/Jueguemos2.jpg'
import Jueguemos3 from '../assets/images/thumbnails/Jueguemos3.jpg'
import Jueguemos4 from '../assets/images/thumbnails/Jueguemos4.jpg'
import Jueguemos5 from '../assets/images/thumbnails/Jueguemos5.jpg'
import Jueguemos6 from '../assets/images/thumbnails/Jueguemos6.jpg'
import Jueguemos7 from '../assets/images/thumbnails/Jueguemos7.jpg'
import Jueguemos8 from '../assets/images/thumbnails/Jueguemos8.jpg'
import Jueguemos9 from '../assets/images/thumbnails/Jueguemos9.jpg'
import Jueguemos10 from '../assets/images/thumbnails/Jueguemos10.jpg'*/
import DMBLogo from '../assets/images/logo/LogoDMB.png'
//import LBLogo from '../assets/images/logo/LogoLB.png'
//import CreepyLogo from '../assets/images/logo/LogoCreepy.png'
import PDLogo from '../assets/images/logo/LogoPD.png'
/*import CWLogo from '../assets/images/logo/LogoCW.png'
import JALogo from '../assets/images/logo/LogoJA.png'
import JAP1 from '../assets/images/preview/JAP1.png'
import JAP2 from '../assets/images/preview/JAP2.png'
import JAP3 from '../assets/images/preview/JAP3.png'
import JAP4 from '../assets/images/preview/JAP4.png'
import JAP5 from '../assets/images/preview/JAP5.png'
import JAP6 from '../assets/images/preview/JAP6.png'
import JAP7 from '../assets/images/preview/JAP7.png'
import JAP8 from '../assets/images/preview/JAP8.png'
import JAP9 from '../assets/images/preview/JAP9.png'
import JAP10 from '../assets/images/preview/JAP10.png'
import CreepyP1 from '../assets/images/preview/CreepyP1.png'
import CreepyP2 from '../assets/images/preview/CreepyP2.png'
import CreepyP3 from '../assets/images/preview/CreepyP3.png'
import CreepyP4 from '../assets/images/preview/CreepyP4.png'
import PDP1 from '../assets/images/preview/PDP1.png'
import PDP2 from '../assets/images/preview/PDP2.png'
import PDP3 from '../assets/images/preview/PDP3.png'
import PDP4 from '../assets/images/preview/PDP4.png'
import CWP1 from '../assets/images/preview/CWP1.png'
import CWP2 from '../assets/images/preview/CWP2.png'
import LBP1 from '../assets/images/preview/LBP1.png'
import LBP2 from '../assets/images/preview/LBP2.png'
import LBP3 from '../assets/images/preview/LBP3.png'
import LBP4 from '../assets/images/preview/LBP4.png'
import LBP5 from '../assets/images/preview/LBP5.png'
import LBP6 from '../assets/images/preview/LBP6.png'
import LBP7 from '../assets/images/preview/LBP7.png'
import LBP8 from '../assets/images/preview/LBP8.png'
import LBP9 from '../assets/images/preview/LBP9.png'
import LBP10 from '../assets/images/preview/LBP10.png'
import LBP11 from '../assets/images/preview/LBP11.png'
import LBP12 from '../assets/images/preview/LBP12.png'
import LBP13 from '../assets/images/preview/LBP13.png'
import LBP14 from '../assets/images/preview/LBP14.png'
import LBP15 from '../assets/images/preview/LBP15.png'
import LBP161 from '../assets/images/preview/LBP161.png'
import LBP162 from '../assets/images/preview/LBP162.png'
import LBP17 from '../assets/images/preview/LBP17.png'
import LBP18 from '../assets/images/preview/LBP18.png'
import LBP19 from '../assets/images/preview/LBP19.png'
import LBPH from '../assets/images/preview/LBPH.png'
import LBPA from '../assets/images/preview/LBPA.png'
import LBPN from '../assets/images/preview/LBPN.png'
import LBP201 from '../assets/images/preview/LBP201.png'
import LBP202 from '../assets/images/preview/LBP202.png'
import S20001 from '../assets/images/thumbnails/2000S1.jpg'
import S20001P from '../assets/images/preview/2000S1P.png'
import DMLT from '../assets/images/thumbnails/DML.jpg'
import DMLP from '../assets/images/preview/DMLP.png'
import LBTPDT from '../assets/images/thumbnails/LBTPDT.png'
import LBTPD from '../assets/images/preview/LBTPD.png'
import QPCLBT from '../assets/images/thumbnails/QPCLBT.png'
import QPCLBP from '../assets/images/preview/QPCLBP.png'*/
import TMDLOGO from '../assets/images/logo/logotmd.jpg'
/*import E2000S2 from '../assets/images/thumbnails/2000S.png'
import S2000SP from '../assets/images/preview/S2000SP.png'
import CADMBP from '../assets/images/preview/CADMBP.png'
import PDP5 from '../assets/images/preview/PDP5.png'
import PDP6 from '../assets/images/preview/PDP6.png'
import CreepyP5 from '../assets/images/preview/CreepyP5.png'
import DMBDP from '../assets/images/preview/DMBDP.png'
import DMBPT1 from '../assets/images/preview/DMBPT1.png'
import DMBPT2 from '../assets/images/preview/DMBPT2.png'
import DMBPT3 from '../assets/images/preview/DMBPT3.png'
import DMB85T from '../assets/images/thumbnails/DMB85T.png'
import DMB105T from '../assets/images/thumbnails/DMB105T.jpg'
import PD6T from '../assets/images/thumbnails/PD6T.jpg'
import PD7 from '../assets/images/thumbnails/PD7.png'
import PDP7 from '../assets/images/preview/PDP7.png'
import Creepy5T from '../assets/images/thumbnails/Creepy5T.jpg'
import Creepys6 from '../assets/images/thumbnails/Creepy6.png'
import CreepyP6 from '../assets/images/preview/CreepyP6.png'
import DMB12TP from '../assets/images/preview/LOPDMB12T.png'
import DMB12T from '../assets/images/thumbnails/LOPDMB12T.jpg'
import DMB13TP from '../assets/images/preview/DMB13TP.png'
import DMB13T from '../assets/images/thumbnails/DMBEP13TT.png'
import JAT1 from '../assets/images/thumbnails/JAH1.png'
import JAP1T from '../assets/images/preview/JAH1P.png'
import JAT2 from '../assets/images/thumbnails/JAH2.png'
import JAP2T from '../assets/images/preview/JAH2P.png'*/
import PD8 from '../assets/images/thumbnails/PD8.png'
import PDP8 from '../assets/images/preview/PD8.png'
/*import PD7T from '../assets/images/thumbnails/PD7T.png'
import PD7TP from '../assets/images/thumbnails/PD7T.png'
import PD8T from '../assets/images/thumbnails/PD8T.png'
import ENTRETT from '../assets/images/thumbnails/ENTRETT.png'
import JATR from '../assets/images/thumbnails/JAT.png'
import LBTPDT2 from '../assets/images/thumbnails/LBTPDTT.png'
import DOM from '../assets/images/thumbnails/DOMINO.jpg'
import DMBR from '../assets/images/thumbnails/DMBR.jpg'*/
import TMDT from '../assets/images/thumbnails/TMD.jpg'
import PCA from '../assets/images/thumbnails/PYA.jpg'
import ENTRET from '../assets/images/thumbnails/ENTRET.png'
import ENTREP from '../assets/images/preview/ENTREP.png'


const episodes = [
  /*
  {
    
    id: 1,
    section: 'DMB',
    title: 'Episodio 1 : Un Nuevo Plan',
    thumbnailUrl: DMB1,
    webUrl: 'https://www.youtube.com/embed/TZijjc32tkw',
    backgroundImage: DMBP1,
    seriesLogo: DMBLogo,
    description: 'El epico desmadre comienza!',
  },
  {
    id: 2,
    section: 'DMB',
    title: 'Episodio 2 : Sendero al Mal',
    thumbnailUrl: DMB2,
    webUrl: 'https://www.youtube.com/embed/mB9anl-5yVw',
    backgroundImage: DMBP2,
    seriesLogo: DMBLogo,
    description: 'Mario y Luigi se aventuran al castillo de Bowser para salvar a la princesa Peach.',
  },
  {
    id: 3,
    section: 'DMB',
    title: 'Episodio 3 : El Castillo de Bowser',
    thumbnailUrl: DMB3,
    webUrl: 'https://www.youtube.com/embed/8dEokaQOw4A', // Add the episode URL
    backgroundImage: DMBP3,
    seriesLogo: DMBLogo,
    description: 'Mario y Luigi se enfrentan al castillo de Bowser!',
  },
  {
    id: 4,
    section: 'DMB',
    title: 'Episodio 4 : El Sabio Washatumorra',
    thumbnailUrl: DMB4,
    webUrl: 'https://www.youtube.com/embed/orctsFMh_QA', // Add the episode URL
    backgroundImage: DMBP4,
    seriesLogo: DMBLogo,
    description: 'Los heroes van con el sabio del Reino Champiñón a pedir ayuda.',
  },
  {
    id: 5,
    section: 'DMB',
    title: 'Episodio 5 : Una Nueva Esperanza',
    thumbnailUrl: DMB5,
    webUrl: 'https://www.youtube.com/embed/EH6UmAq498Q', // Add the episode URL
    backgroundImage: DMBP5,
    seriesLogo: DMBLogo,
    description: 'Los heroes se dirijen al Castillo de Peach en busca de una de las únicas cosas que pueden vencer a Bowser.',
  },
  {
    id: 6,
    section: 'DMB',
    title: 'Episodio 6 : ¿El Juego del Miedo?...',
    thumbnailUrl: DMB6,
    webUrl: 'https://www.youtube.com/embed/-EF_khClTVs', // Add the episode URL
    backgroundImage: DMBP6,
    seriesLogo: DMBLogo,
    description: 'Antes de poder conseguir la esfera sagrada deben superar un reto.',
  },
  {
    id: 7,
    section: 'DMB',
    title: 'Episodio 7 : Un Mientras Tanto con Bowser',
    thumbnailUrl: DMB7,
    webUrl: 'https://www.youtube.com/embed/rtMC_l46QSs', // Add the episode URL
    backgroundImage: DMBP7,
    seriesLogo: DMBLogo,
    description: 'Vemos lo que ocurre con Bowser mientras los héroes buscan la segunda esfera sagrada.',
  },
  {
    id: 8,
    section: 'DMB',
    title: 'Episodio 8 : El Club de Comedia',
    thumbnailUrl: DMB8,
    webUrl: 'https://www.youtube.com/embed/tAyD8nioOd4', // Add the episode URL
    backgroundImage: DMBP8,
    seriesLogo: DMBLogo,
    description: 'Los héroes llegan al club de comedia Bickolt y encuentran al hijo del sabio.',
  },
  {
    id: 9,
    section: 'DMB',
    title: 'Dúper Mario Bros - Episodio 8.5 (Escena Eliminada)',
    thumbnailUrl: DMB85,
    webUrl: 'https://www.youtube.com/embed/3vVHDTD-qU', // Add the episode URL
    backgroundImage: DMBP85,
    seriesLogo: DMBLogo,
    description: 'Recuerden que esto no es el resultado final, aún hay cosas que se van a ajustar (como el uso de groserías), la forma de grabar, etc. Recuerden que esta continuación es para todos y si tienen sugerencias, estas se van a recibir y usar para entregar un mejor producto ya cuando más importe, en el Episodio 12 Pt. 2. Vean esto como un video para probar las aguas.',
  },
  {
    id: 10,
    section: 'DMB',
    title: 'Episodio 9 : La Posesión',
    thumbnailUrl: DMB9,
    webUrl: 'https://www.youtube.com/embed/umJg0OmZjno', // Add the episode URL
    backgroundImage: DMBP9,
    seriesLogo: DMBLogo,
    description: '¿Que sera de Mario?... ',
  },
  {
    id: 11,
    section: 'DMB',
    title: 'Episodio 10 : La Hora de Brillar de Luigi',
    thumbnailUrl: DMB10,
    webUrl: 'https://www.youtube.com/embed/zUj9pT_xyLY', 
    backgroundImage: DMBP10,
    seriesLogo: DMBLogo,
    description: 'Los heroes se adentran en el Templo Sagrado para poder salvar a Mario. ',
  },
  {
    id: 12,
    section: 'DMB',
    title: 'Episodio 10.5 : La Hora de Brillar del Vendedor',
    thumbnailUrl: DMB105,
    webUrl: 'https://www.youtube.com/embed/ZkRgXgmqemM', // Add the episode URL
    backgroundImage: DMBP105,
    seriesLogo: DMBLogo,
    description: 'El vendedor regresa!! y esta vez tiene un nuevo trabajo en el restaurante "EL ITALIANO". No se pierdan esta extención de episodio este 25 de Diciembre!!',
  },
  {
    id: 13,
    section: 'DMB',
    title: 'Episodio 11 : El Shadowken',
    thumbnailUrl: DMB11,
    webUrl: 'https://www.youtube.com/embed/Mvk5t1jL1Nw', // Add the episode URL
    backgroundImage: DMBP11,
    seriesLogo: DMBLogo,
    description: 'Soul tiene otros planes, ¿podrán los héroes detenerlo?',
  },
  {
    id: 14,
    section: 'DMB',
    title: 'UNA PARTE DEL Episodio 12',
    thumbnailUrl: DMB12,
    webUrl: 'https://www.youtube.com/embed/jlIA9Q58Sxs', // Add the episode URL
    backgroundImage: DMBP12,
    seriesLogo: DMBLogo,
    description: 'La cuenta regresiva empieza. ¿Qué harán nuestros héroes para vencer a Soul?',
  },
  {
    id: 15,
    section: 'DMB',
    title: 'LA OTRA PARTE DEL Episodio 12 : Una Nueva Misión',
    thumbnailUrl: DMB125,
    webUrl: 'https://www.youtube.com/embed/NIDoa2Rprk0', // Add the episode URL
    backgroundImage: DMBP125,
    seriesLogo: DMBLogo,
    description: 'Nuestros heroes siguen su meta de conseguir las esferas sagradas. Pero se encontrarán con viejos y nuevos retos en su camino al siguiente destino...',
  },
  {
    id: 16,
    section: 'DMB',
    title: 'Episodio 13 : La Torre Sagrada',
    thumbnailUrl: DMB13,
    webUrl: 'https://www.youtube.com/embed/q8H8WdX04tM', // Add the episode URL
    backgroundImage: DMBP13,
    seriesLogo: DMBLogo,
    description: '¡Johnny está en peligro! Separado del grupo, Toad tropieza con una persona familiar. Mientras tanto, los errores del pasado asechan a Mario, y nuestros heroes se enfrentan a un dilema que pondrá a prueba su lealtad. ¿Hasta dónde están dispuestos a llegar por las esferas sagradas?',
  },
  {
    id: 1,
    section: 'LB',
    title: 'Episodio 1 - Canto Mortal',
    thumbnailUrl: LB1,
    webUrl: 'https://www.youtube.com/embed/-2qNI84dqqQ', // Add the episode URL
    backgroundImage: LBP1,
    seriesLogo: LBLogo,
    description: '',
  },
  {
    id: 2,
    section: 'LB',
    title: 'Episodio 2 - Atropellado',
    thumbnailUrl: LB2,
    webUrl: 'https://www.youtube.com/embed/PkIP9VdQ-4U', // Add the episode URL
    backgroundImage: LBP2,
    seriesLogo: LBLogo,
    description: '',
  },
  {
    id: 3,
    section: 'LB',
    title: 'Episodio 3 - Burro y el Lego Espía',
    thumbnailUrl: LB3,
    webUrl: 'https://www.youtube.com/embed/hn70ltmW7xk', // Add the episode URL
    backgroundImage: LBP3,
    seriesLogo: LBLogo,
    description: 'Este es un Remake de el viejo video Legobob EP 3 - El misterio de Igor. Para decirles las verdad : Para mi era muy embarasoso el video Legobob EP 3 - El misterio de Igor, ya que en mi opinion me había quedado mal, y quería quitarlo de youtube,  pero no quería dejarlos sin un EP 3, así que hize esto.',
  },
  {
    id: 4,
    section: 'LB',
    title: 'Episodio 4 - Especial Navideño 2010',
    thumbnailUrl: LB4,
    webUrl: 'https://www.youtube.com/embed/iMwiSnQlWa8', // Add the episode URL
    backgroundImage: LBP4,
    seriesLogo: LBLogo,
    description: 'Llegó la navidad!, legobob esta muy emocionado por abrir sus regalos, pero cuando digo emocionado significa EMOCIONADO!',
  },
  {
    id: 5,
    section: 'LB',
    title: 'Episodio 5 - Alerta Meteoros',
    thumbnailUrl: LB5,
    webUrl: 'https://www.youtube.com/embed/p-jyRqkElwc', // Add the episode URL
    backgroundImage: LBP5,
    seriesLogo: LBLogo,
    description: 'El pronostico anunció una lluvia de meteoros, ahora Legobob tratará de evitar ser meteorizado, acertará o fallará???',
  },
  {
    id: 6,
    section: 'LB',
    title: 'Episodio 6 - SkateBob al Extremo',
    thumbnailUrl: LB6,
    webUrl: 'https://www.youtube.com/embed/SsHckk9_K2w', // Add the episode URL
    backgroundImage: LBP6,
    seriesLogo: LBLogo,
    description: 'Legobob entra a un concurso de skateboarding, ahora Legobob debe conseguir un skateboard y competir',
  },
  {
    id: 7,
    section: 'LB',
    title: 'Episodio 7 - Dustin el Lego',
    thumbnailUrl: LB7,
    webUrl: 'https://www.youtube.com/embed/kaa59TRAXTY', // Add the episode URL
    backgroundImage: LBP7,
    seriesLogo: LBLogo,
    description: 'Legobob se accidentó gravemente y no podrá hacer el episodio, afortunadamente contrató a alguien más para encargarse de eso!',
  },
  {
    id: 8,
    section: 'LB',
    title: 'Episodio 8 - Mugroso Musculoso',
    thumbnailUrl: LB8,
    webUrl: 'https://www.youtube.com/embed/F-GC6bGxeBs', // Add the episode URL
    backgroundImage: LBP8,
    seriesLogo: LBLogo,
    description: 'Burro esta interesado en ganar $10,000, para eso debe ganar un concurso de fuerza, pero a veces  ser muy fuerte se te sube a la cabeza.',
  },
  {
    id: 9,
    section: 'LB',
    title: 'Episodio 9 - Burro VS Dustin Versión 2.0',
    thumbnailUrl: LB9,
    webUrl: 'https://www.youtube.com/embed/4DVGwxYJ3qY', // Add the episode URL
    backgroundImage: LBP9,
    seriesLogo: LBLogo,
    description: 'La historia es la misma, pero la versión 2.0 incluye : - Mejor calidad de video - Mejor calidad de audio - Intro nueva (como la del EP 12) - Subtitulaje (Inglés) - Parte final nueva - Pelea mejorada - Canciónes diferentes (In The End, Breaking the habits)',
  },
  {
    id: 10,
    section: 'LB',
    title: 'Episodio 10 - Pikachú en la Aventura',
    thumbnailUrl: LB10,
    webUrl: 'https://www.youtube.com/embed/a__VYyVDOLU', // Add the episode URL
    backgroundImage: LBP10,
    seriesLogo: LBLogo,
    description: 'Legobob encuentra un nuevo amigo, pero no tiene idea de que Pikachu tiene un duro secreto.',
  },
  {
    id: 11,
    section: 'LB',
    title: 'Episodio 11 - La Enfermedad de la PierdePiezSitis',
    thumbnailUrl: LB11,
    webUrl: 'https://www.youtube.com/embed/lBhqgK1JwDY', // Add the episode URL
    backgroundImage: LBP11,
    seriesLogo: LBLogo,
    description: 'A Legobob le llega la más espantosa y mortal enfermedad de lego : La pierdepiezsitis',
  },
  {
    id: 12,
    section: 'LB',
    title: 'Episodio 12 - La Amenaza',
    thumbnailUrl: LB12,
    webUrl: 'https://www.youtube.com/embed/0rJs3rSOk3s', // Add the episode URL
    backgroundImage: LBP12,
    seriesLogo: LBLogo,
    description: 'Burro y Pikachu han sido secuestrados, ¿por quien? ¿por qué? descubrelo en este emocionante episodio. Y gracias a TheLuigiDimension por la ayuda!',
  },
  {
    id: 13,
    section: 'LB',
    title: 'Episodio 13 - Super Mario',
    thumbnailUrl: LB13,
    webUrl: 'https://www.youtube.com/embed/yKkjOyPPrnU', // Add the episode URL
    backgroundImage: LBP13,
    seriesLogo: LBLogo,
    description: 'Una visita inesperada llega con Legobob persiguiendo a su archienemigo.',
  },
  {
    id: 14,
    section: 'LB',
    title: 'Episodio 14 - Jigsaw y el Juego de la Muerte',
    thumbnailUrl: LB14,
    webUrl: 'https://www.youtube.com/embed/aQ-7IEkLO5s', // Add the episode URL
    backgroundImage: LBP14,
    seriesLogo: LBLogo,
    description: 'Pikachu ha sido secuestrado por el amante de juegos asesinos Jigsaw. La verdad no tenía planeado este episodio, una vez vi a mi hermano jugando el videojuego de Saw 2 Flesh and Blood, y tantas trampas me inspiraron a hacer esto.',
  },
  {
    id: 15,
    section: 'LB',
    title: 'Episodio 15 - El VerdeBob',
    thumbnailUrl: LB15,
    webUrl: 'https://www.youtube.com/embed/16YMpzZg7HM', // Add the episode URL
    backgroundImage: LBP15,
    seriesLogo: LBLogo,
    description: 'Legobob consigue unas piezas verdes que lo empiezan a volver cretinamente malo. ¿Podrán sus amigos hacer algo con este caos?',
  },
  {
    id: 16,
    section: 'LB',
    title: 'Episodio 16 Parte 1 - SkateBob a lo Supremo',
    thumbnailUrl: LB161,
    webUrl: 'https://www.youtube.com/embed/I6ab2XzYxeM', // Add the episode URL
    backgroundImage: LBP161,
    seriesLogo: LBLogo,
    description: 'La segunda parte del torneo de Skateboarding llegó, mientras tanto Mario actúa como nunca antes lo había hecho. Nota : A partir de este episodio, TheLuigiDimension es parte de LegoBob tambien al actuar como el mario que aparece en este episodio.',
  },
  {
    id: 17,
    section: 'LB',
    title: 'Episodio 16 Parte 2 - Parecidos y Viejos Enemigos',
    thumbnailUrl: LB162,
    webUrl: 'https://www.youtube.com/embed/Y4rQoAY_16I', // Add the episode URL
    backgroundImage: LBP162,
    seriesLogo: LBLogo,
    description: 'Despues de enterarse de que hay 2 Marios, la aventura se vuelve mas emocionante y peligrosa en una batalla entre parecidos y viejos enemigos.',
  },
  {
    id: 18,
    section: 'LB',
    title: 'Episodio 17 - El Club de Comedia',
    thumbnailUrl: LB17,
    webUrl: 'https://www.youtube.com/embed/f0IEkzu3A7s', // Add the episode URL
    backgroundImage: LBP17,
    seriesLogo: LBLogo,
    description: 'Legobob se inscribe de comediante en un club de comedia.',
  },
  {
    id: 19,
    section: 'LB',
    title: 'Episodio 18 - Problemas con Yoshi',
    thumbnailUrl: LB18,
    webUrl: 'https://www.youtube.com/embed/w3GO4aLA5t0', // Add the episode URL
    backgroundImage: LBP18,
    seriesLogo: LBLogo,
    description: 'Mario encuentra un huevo de yoshi y esta dispuesto a cuidarlo.',
  },
  {
    id: 20,
    section: 'LB',
    title: 'Episodio 19 - Captura la Bandera',
    thumbnailUrl: LB19,
    webUrl: 'https://www.youtube.com/embed/odtAWR0EfY4', // Add the episode 
    backgroundImage: LBP19,
    seriesLogo: LBLogo,
    description: 'Pikachu apuesta su casa en un juego de captura la bandera contra el campéon.',
  },
  {
    id: 21,
    section: 'LB',
    title: 'Especial de Halloween',
    thumbnailUrl: LBH,
    webUrl: 'https://www.youtube.com/embed/F4d19FeMEQg', // Add the episode URL
    backgroundImage: LBPH,
    seriesLogo: LBLogo,
    description: 'Fueron 10 dias de retraso pero por fin está aqui, disfrutenlo!',
  },
  {
    id: 22,
    section: 'LB',
    title: 'Fiesta de Aniversario',
    thumbnailUrl: LBA,
    webUrl: 'https://www.youtube.com/embed/gB6fQ2wQYt4', // Add the episode URL
    backgroundImage: LBPA,
    seriesLogo: LBLogo,
    description: 'Ya pasó 1 año :D',
  },{
    id: 23,
    section: 'LB',
    title: 'Especial Navideño 2011',
    thumbnailUrl: LBN,
    webUrl: 'https://www.youtube.com/embed/dnOBdtKD-Z8', // Add the episode URL
    backgroundImage: LBPN,
    seriesLogo: LBLogo,
    description: 'Bowser se roba los regalos navideños, hora de recuperarlos! Gracias a "Carlitos15151511" por darme la idea de que alguien se roba los regalos de navidad!',
  },
  {
    id: 24,
    section: 'LB',
    title: 'Episodio 20 - LegoCatastrofes Parte 1',
    thumbnailUrl: LB201,
    webUrl: 'https://www.youtube.com/embed/9x2i1n6xD_c', // Add the episode URL
    backgroundImage: LBP201,
    seriesLogo: LBLogo,
    description: 'Inicia el final.',
  },
  {
    id: 25,
    section: 'LB',
    title: 'Episodio 20 - LegoCatastrofes Parte 2',
    thumbnailUrl: LB202,
    webUrl: 'https://www.youtube.com/embed/Y6zO5KOBtcE', // Add the episode URL
    backgroundImage: LBP202,
    seriesLogo: LBLogo,
    description: 'Todo termina.',
  },
  {
    id: 26,
    section: 'LB',
    title: 'LegoBob EP 1 - Canto Mortal (13 Aniversario)',
    thumbnailUrl: LB13A,
    webUrl: 'https://www.youtube.com/embed/iX4HgHfnesk', // Add the episode URL
    backgroundImage: LB13A,
    seriesLogo: LBLogo,
    description: 'Despues de tanto tiempo, LegoBob encuentra sus piernas y su boca original. Ahora decide recrear el primer episodio de su serie para ver si todavía tiene el toque que lo hizo famoso... No esperen info. del canal en este video, comoquiera recuerden quedarse hasta el final ;)',
  },
  {
    id: 1,
    section: 'CW',
    title: 'Navidad 2012',
    thumbnailUrl: CW1,
    webUrl: 'https://www.youtube.com/embed/ys2mWWBs3J8', // Add the episode URL
    backgroundImage: CWP1,
    seriesLogo: CWLogo,
    description: 'Inicio esta nueva mini serie de animaciónes simples para entrenar mi habilidad esta... Tanpoco me pregunten cuando sale el próximo POR FAVOR, aunque estoy pensando en hacer uno de Año Nuevo, no es oficial eh, en fin, Feliz Navidad!',
  },
  {
    id: 2,
    section: 'CW',
    title: 'Año Nuevo',
    thumbnailUrl: CW2,
    webUrl: 'https://www.youtube.com/embed/n-043mXislc', // Add the episode URL
    backgroundImage: CWP2,
    seriesLogo: CWLogo,
    description: 'En Navidad y Año Nuevo (sobre todo Año Nuevo) mucha gente acostumbra disparar al cielo como si estuvieran "matando el año" PUES NO LO HAGAN! No sabes a que le caerán tus balas, puedes dañar las pertenencias de otros o hasta quitarle la vida a algúnos. Este episodio está más corto que el anterior pero solo tuve 1 semana para desarrollarlo, ojala me entiendan, Navidad y Año Nuevo son épocas muy pegadas, pero disfrutenlo :)',
  },
  {
    id: 1,
    section: 'Creepy',
    title: 'Super Mario 64 : El Course 16',
    thumbnailUrl: Creepys1,
    webUrl: 'https://www.youtube.com/embed/U9lMfadqhGo', // Add the episode URL
    backgroundImage: CreepyP1,
    seriesLogo: CreepyLogo,
    description: 'Mi primer Creepypasta al igual que mi primer video loquendo, no sean duros conmigo, que es mi primera ves haciendo ambas cosas asi que tengo derecho a equivocarme ;)',
  },
  {
    id: 2,
    section: 'Creepy',
    title: "Zelda Majora's Mask : La Máscara de la Condena",
    thumbnailUrl: Creepys2,
    webUrl: 'https://www.youtube.com/embed/xNL6MFuyB5k', // Add the episode URL
    backgroundImage: CreepyP2,
    seriesLogo: CreepyLogo,
    description: 'Si si, se que está muy largo, es que mi imaginación fue más allá de lo que creí que podría ir cuando hice éste Creepypasta. Recuerden no ir al cementerio de Ikana en el cuarto día...',
  },
  {
    id: 3,
    section: 'Creepy',
    title: 'El Despertador',
    thumbnailUrl: Creepys3,
    webUrl: 'https://www.youtube.com/embed/BWcKaqdVc1k', // Add the episode URL
    backgroundImage: CreepyP3,
    seriesLogo: CreepyLogo,
    description: 'Este TANPOCO es el video ganador de la votación de 2000 Subs, de nuevo, el verdadero ganador está demorando, y de mientras este XD. Bueno, esta historia, la escribí NO con el propósito de cagarte muuuucho de miedo, sino con el de hacer una más extensa, compleja, y completa que mis 2 Creepypastas anteriores, ojala les guste, y por favor pónganle atención :) Pero parece que si los cagó de miedo..... ._.',
  },
  {
    id: 4,
    section: 'Creepy',
    title: 'Toc Toc',
    thumbnailUrl: Creepys4,
    webUrl: 'https://www.youtube.com/embed/AJB2hy8WIgA', // Add the episode URL
    backgroundImage: CreepyP4,
    seriesLogo: CreepyLogo,
    description: 'Feliz Halloween :) Bueno, este es mi primer Creepypasta EN TERCERA PERSONA, oajala les guste :D. Y cuidado al abrir la puerta, nunca sabes si en verdad se trata de un niño en busca de dulces...',
  },
      {
        id: 5,
        section: 'Creepy',
        title: 'Creepypasta : Mira atrás de tí X Marlo [Loquendo]',
        thumbnailUrl: Creepys5,
        webUrl: 'https://www.youtube.com/embed/4qA-7Z3pEvQ', // Add the episode URL
        backgroundImage: CreepyP5,
        seriesLogo: CreepyLogo,
        description: 'Bienvenidos al especial de Halloween!! Aquí se mostrarán 2 Creepypastas hechos por la comunidad: Mira atrás de tí por Juan Andrés Briceño:  juanandr3sbricen0  / Marlo por Viche Mimi: https://www.facebook.com/profile.php?...',
      },
      {
        id: 6,
        section: 'Creepy',
        title: 'LegoBob || ¿Te Parece Divertido?',
        thumbnailUrl: Creepys6,
        webUrl: 'https://www.youtube.com/embed/Lu_9HJBovso', // Add the episode URL
        backgroundImage: CreepyP6,
        seriesLogo: CreepyLogo,
        description: 'Despues de cobrar venganza contra Rodrigo, LegoBob regresa a terminar con lo que empezó. ¿Logrará Burro resolver este gran misterio a tiempo? \n Este video está basado en la Creepypasta hecha por Rodrigo TheMarioDimension. No es parte del canon de LegoBob ni Dúper Mario Bros.',
      },
      {
        id: 1,
        section: 'PD',
        title: 'Preguntas Dimensionales #1',
        thumbnailUrl: PD1,
        webUrl: 'https://www.youtube.com/embed/E69nkL_ZcHs', // Add the episode URL
        backgroundImage: PDP1,
        seriesLogo: PDLogo,
        description: 'Dejen todas sus preguntas en los comentarios. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
      },
      {
        id: 2,
        section: 'PD',
        title: 'Preguntas Dimensionales #2',
        thumbnailUrl: PD2,
        webUrl: 'https://www.youtube.com/embed/vpSBfJOlPLs', // Add the episode URL
        backgroundImage: PDP2,
        seriesLogo: PDLogo,
        description: 'No olviden hacer TODAS LAS PREGUNTAS que se les antoje, adelante, recuerden, tienen 1 mes. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
      },
      {
        id: 3,
        section: 'PD',
        title: 'Preguntas Dimensionales #3',
        thumbnailUrl: PD3,
        webUrl: 'https://www.youtube.com/embed/_-oyOxnP_wg', // Add the episode URL
        backgroundImage: PDP3,
        seriesLogo: PDLogo,
        description: 'Favor de ver el video completo antes de hacer sus preguntas nuevas. Si usted se sintió ofendido con este video le pido una disculpa, mi única intención es hacerle reir y entretenerle. EL TIEMPO PARA ENVÍAR PREGUNTAS HA TERMINADO.',
      },
      {
        id: 4,
        section: 'PD',
        title: 'Preguntas Dimensionales #4',
        thumbnailUrl: PD4,
        webUrl: 'https://www.youtube.com/embed/BtvfCnNGeu0', // Add the episode URL
        backgroundImage: PDP4,
        seriesLogo: PDLogo,
        description: 'Disculpen la tardanza pero finalmente aquí está la cuarta parte!! Disfrutenlo :] Y no olviden enviar sus preguntas, recuerden que tienen tiempo hasta que yo les avise, pero les aseguro que es más de 1 mes, aún así, no vayan a enviar sus preguntas hasta el final... quiero preguntas.... ahora...... .___. Okno XD',
      },
      {
        id: 5,
        section: 'PD',
        title: 'Preguntas Dimensionales #5',
        thumbnailUrl: PD5,
        webUrl: 'https://www.youtube.com/embed/FuR-dqSdLko', // Add the episode URL
        backgroundImage: PDP5,
        seriesLogo: PDLogo,
        description: 'Link y Ezlo regresan con nuevas preguntas!',
      },
      {
        id: 6,
        section: 'PD',
        title: 'Preguntas Dimensionales #6',
        thumbnailUrl: PD6,
        webUrl: 'https://www.youtube.com/embed/ZpcBKT_tisE', // Add the episode URL
        backgroundImage: PDP6,
        seriesLogo: PDLogo,
        description: 'Visuales (Ezlo):  @TomySiete',
      },
      {
        id: 7,
        section: 'PD',
        title: 'Preguntas Dimensionales #7',
        thumbnailUrl: PD7,
        webUrl: 'https://www.youtube.com/embed/NNqKGVbn2B8', // Add the episode URL
        backgroundImage: PDP7,
        seriesLogo: PDLogo,
        description: 'Visuales (Ezlo):  @TomySiete',
      },
      {
        id: 1,
        section: 'Jueguemos',
        title: 'Minecraft Supervivencia Parte 1 - Cuanta lana negra!',
        thumbnailUrl: Jueguemos1,
        webUrl: 'https://www.youtube.com/embed/7xOnUIQmIvM', // Add the episode URL
        backgroundImage: JAP1,
        seriesLogo: JALogo,
        description: 'Iniciamos con esta madre!',
      },
      {
        id: 2,
        section: 'Jueguemos',
        title: 'Minecraft Supervivencia Parte 2 - Matando Cerditos Inocentes :D',
        thumbnailUrl: Jueguemos2,
        webUrl: 'https://www.youtube.com/embed/B-AuqkSJUxQ', // Add the episode URL
        backgroundImage: JAP2,
        seriesLogo: JALogo,
        description: 'Seguimos con esta madre!',
      },
      {
        id: 3,
        section: 'Jueguemos',
        title: 'Minecraft Supervivecia Parte 3 - Publicidad Barata',
        thumbnailUrl: Jueguemos3,
        webUrl: 'https://www.youtube.com/embed/pregQbuk_dY', // Add the episode URL
        backgroundImage: JAP3,
        seriesLogo: JALogo,
        description: 'Entren al server de Endo : endo.servegame.com Y jueguen conmigo, mi nombre de usuario es Rogumer.',
      },
      {
        id: 4,
        section: 'Jueguemos',
        title: 'Minecraft Supervivencia Parte 4 - Nos Alejamos de Casa',
        thumbnailUrl: Jueguemos4,
        webUrl: 'https://www.youtube.com/embed/AbPugw73XRY', // Add the episode URL
        backgroundImage: JAP4,
        seriesLogo: JALogo,
        description: 'Esta madre se empieza a poner interesante ahora que porfin nos alejamos de casa!',
      },
      {
        id: 5,
        section: 'Jueguemos',
        title: 'Minecraft Supervivencia Parte 5 - I Am Error...',
        thumbnailUrl: Jueguemos5,
        webUrl: 'https://www.youtube.com/embed/8fEGsrt8tlo', // Add the episode URL
        backgroundImage: JAP5,
        seriesLogo: JALogo,
        description: 'We continue with this shit!',
      },
      {
        id: 6,
        section: 'Jueguemos',
        title: 'Minecraft CO-OP Parte 1 - Desmadre al Triple!',
        thumbnailUrl: Jueguemos6,
        webUrl: 'https://www.youtube.com/embed/gAE_aMo90Zc', // Add the episode URL
        backgroundImage: JAP6,
        seriesLogo: JALogo,
        description: 'Este video NO es el ganador de la votación de 2000 Subs, el verdadero está tomando un tiempo, y de mientras subo esto, disfrutenlo, que ahora tenemos de compañía a 2 de mis amigos de los que he hablado varias veces, por fin van a conocer a estos 2 desmadrosos XD, y ahora, el desmadre se multiplica por tres!',
      },
      {
        id: 7,
        section: 'Jueguemos',
        title: 'Minecraft CO-OP Parte 2 - Templo del Desierto',
        thumbnailUrl: Jueguemos7,
        webUrl: 'https://www.youtube.com/embed/Mqdicpu8Z6I', // Add the episode URL
        backgroundImage: JAP7,
        seriesLogo: JALogo,
        description: 'Seguimos caminando en busca de comida, topándonos con una casa instantánea!',
      },
      {
        id: 8,
        section: 'Jueguemos',
        title: 'Minecraft CO-OP Parte 3 - Calabozo del End!',
        thumbnailUrl: Jueguemos8,
        webUrl: 'https://www.youtube.com/embed/NjlKigMqss8', // Add the episode URL
        backgroundImage: JAP8,
        seriesLogo: JALogo,
        description: 'Ahora con unas cuantas mejoras tanto visuales como auditivas, continuamos explorando los alrededores del previamente encontrado Templo del Desierto, solo para encontrarnos con el que sería mi mejor descubrimiento en mi historia jugando Minecraft. OJO : El video NO está laggeado, solo lo están las partes que grabó La Chingada, pues al parecer, la PC de La Chingada tiene una memoria RAM de la chingada. Pun Intended ^___^',
      },
      {
        id: 9,
        section: 'Jueguemos',
        title: 'Slender Intento 1 - Lag Everywhere',
        thumbnailUrl: Jueguemos9,
        webUrl: 'https://www.youtube.com/embed/n5zRV0c9t4g', // Add the episode URL
        backgroundImage: JAP9,
        seriesLogo: JALogo,
        description: 'Iniciamos con una montaña de lag -_-',
      },
      {
        id: 10,
        section: 'Jueguemos',
        title: 'Slender Intento 2 - ¿Y Bongo Bongo? [Feat. "La Chingada"]',
        thumbnailUrl: Jueguemos10,
        webUrl: 'https://www.youtube.com/embed/0JNOdHsalZs', // Add the episode URL
        backgroundImage: JAP10,
        seriesLogo: JALogo,
        description: 'Volvemos a intentarlo, ahora con muuucho menos lag, y aparte, estamos acompañados por el señor profesor Dr. Drew Pea Cock! Digo la Chingada.',
      },

      {
        id: 1,
        section: 'Jueguemos2',
        title: 'Jueguemos a: Minecraft Hardcore Parte 1',
        thumbnailUrl: JAT1,
        webUrl: 'https://www.youtube.com/embed/7Q4ek7X8QeQ', // Add the episode URL
        backgroundImage: JAP1T,
        seriesLogo: JALogo,
        description: 'Iniciamos con esta madre!',
      },
      {
        id: 2,
        section: 'Jueguemos2',
        title: 'Jueguemos a: Minecraft Hardcore Parte 2',
        thumbnailUrl: JAT2,
        webUrl: 'https://www.youtube.com/embed/v9ELzficyFc', // Add the episode URL
        backgroundImage: JAP2T,
        seriesLogo: JALogo,
        description: 'Seguimos con esta madre!',
      },
      {
        id: 1,
        section: 'Extra',
        title: '2000 Subs FTW',
        thumbnailUrl: S20001,
        webUrl: 'https://www.youtube.com/embed/mgcaloP3_m8', // Add the episode URL
        backgroundImage: S20001P,
        seriesLogo: TMDLOGO,
        description: 'Muchas muchas gracias! Mi meta en un principio era 1000, pero ahora somos el doble! Realmente, muchas gracias! :)',
      },
      {
        id: 2,
        section: 'Extra',
        title: 'TMD : Draw My Life / Draw My Life in Youtube',
        thumbnailUrl: DMLT,
        webUrl: 'https://www.youtube.com/embed/mgcaloP3_m8', // Add the episode URL
        backgroundImage: DMLP,
        seriesLogo: TMDLOGO,
        description: 'Ustedes lo pidieron, y lo obtuvieron, disculpen la no muy buena calidad, no es fácil grabar un Draw My Life XD. Disfrutenlo, y conozcan un poco más de mi :D. Bueno... por alguna increíblemente extraña razón, muchos creen que yo he insultado al país sudamericano Chile en este video... Y yo así como de O______________________________O WTF!!!! Al decir que no hablaba del país en realidad hablaba del alimento que aquí llamamos "chile", si no lo conoces, es un alimento famoso aquí en México, aún así, no se como rayos se entiende que yo insulté al país, o sea, ¿Dónde diantres se supone que está el insulto? O_O Sería todo lo contrario, en verdad no he visitado esta gran sección del mundo, pero existe el Internet y me he sabido informar sobre su cultura y forma de vivir, que me ha agradado de forma personal influenciando en mis gustos :D',
      },
      {
        id: 3,
        section: 'Extra',
        title: 'DMB Direct',
        thumbnailUrl: DMBD,
        webUrl: 'https://www.youtube.com/embed/3gB2SHpHh9U', // Add the episode URL
        backgroundImage: DMBDP,
        seriesLogo: TMDLOGO,
        description: 'Hola a todos y bienvenidos al directo de DMB, donde encontrarán lo último de información acerca de esta serie. No se olviden de suscribirse, darle like y más importante, compartir. Ojalá lo disfruten y no se olviden de ver de principio a fin...',
      },
      {
        id: 4,
        section: 'Extra',
        title: 'Critiquemos a Dúper Mario Bros',
        thumbnailUrl: CADMB,
        webUrl: 'https://www.youtube.com/embed/VvE-5-9GnKQ', // Add the episode URL
        backgroundImage: CADMBP,
        seriesLogo: TMDLOGO,
        description: 'Hoy toca hacer review a esta amada serie, y que mejor, tambien veremos lo que opinan ustedes!!',
      },
      {
        id: 5,
        section: 'Extra',
        title: '2000 Subs FTW - TheMarioDimension2',
        thumbnailUrl: E2000S2,
        webUrl: 'https://www.youtube.com/embed/D4C8Zs6-Fxo', // Add the episode URL
        backgroundImage: S2000SP,
        seriesLogo: TMDLOGO,
        description: '2000 Subscriptores se dice facil pero es un logro muy grande para este canal. Gracias y vamos por los 10000 :)',
      },
      {
        id: 1,
        section: 'Lost',
        title: '666lego/%bob..o#3# | ¿Te parece Divertido?',
        thumbnailUrl: LBTPDT,
        webUrl: 'https://www.youtube.com/embed/9Fky_KrWY2M', // Add the episode URL
        backgroundImage: LBTPD,
        seriesLogo: CreepyLogo,
        description: '???',
      },
      {
        id: 2,
        section: 'Lost',
        title: '¿Qué Pasó con LegoBob?',
        thumbnailUrl: QPCLBT,
        webUrl: 'https://www.youtube.com/embed/pcK4BzMdFTs', // Add the episode URL
        backgroundImage: QPCLBP,
        seriesLogo: TMDLOGO,
        description: '???',
      },
      {
        id: 3,
        section: 'Lost',
        title: 'Teaser - Duper Mario Bros Ep 8.5 (Escena Eliminada)',
        thumbnailUrl: DMB85T,
        webUrl: 'https://www.youtube.com/embed/-8Syku45SDg', // Add the episode URL
        backgroundImage: DMB85T,
        seriesLogo: DMBLogo,
        description: 'La escena sale el viernes 22 de Septiembre!!',
      },
      {
        id: 4,
        section: 'Lost',
        title: 'Trailer Creepypasta - TheMarioDimension2',
        thumbnailUrl: Creepy5T,
        webUrl: 'https://www.youtube.com/embed/agiWhs-mQL0', // Add the episode URL
        backgroundImage: Creepy5T,
        seriesLogo: CreepyLogo,
        description: '???',
      },
      {
        id: 5,
        section: 'Lost',
        title: '(Trailer) Duper Mario Bros - Episodio 10.5',
        thumbnailUrl: DMB105T,
        webUrl: 'https://www.youtube.com/embed/q5TLhhEJle0', // Add the episode URL
        backgroundImage: DMB105T,
        seriesLogo: DMBLogo,
        description: 'Video deslistado en el canal',
      },
      {
        id: 6,
        section: 'Lost',
        title: 'Teaser',
        thumbnailUrl: S20001P,
        webUrl: 'https://www.youtube.com/embed/BeIN_8ismhM', // Add the episode URL
        backgroundImage: S20001P,
        seriesLogo: TMDLOGO,
        description: 'Este video si se dan cuenta fue subido mucho antes del primer video público en el canal. ¿Porqué será?',
      },
      {
        id: 7,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #6',
        thumbnailUrl: PD6T,
        webUrl: 'https://www.youtube.com/embed/M5MIdv9kglA', // Add the episode URL
        backgroundImage: PD6T,
        seriesLogo: PDLogo,
        description: 'Visuales (Ezlo):  @TomySiete',
      },
      {
        id: 1,
        title: 'Dúper Mario Bros - Teaser',
        thumbnailUrl: DMBT1,
        webUrl: 'https://www.youtube.com/embed/bKQI9IXvD6M', // Add the episode URL
        backgroundImage: DMBPT1,
        seriesLogo: DMBLogo,
        description: 'Así es, la continuación de Dúper Mario Bros está en desarrollo. Sé que hay muchas preguntas pero paciencia, todo a su tiempo.',
      },
      {
        id: 2,
        title: 'Dúper Mario Bros - Teaser #2',
        thumbnailUrl: DMBT2,
        webUrl: 'https://www.youtube.com/embed/Fb5PmM9maJw', // Add the episode URL
        backgroundImage: DMBPT2,
        seriesLogo: DMBLogo,
        description: 'La aventura continua, y con ella nuevos retos... Lo mostrado en este teaser está sujeto a cambiar y no tepresenta el resultado final (Voces, visuales y música serán mejor)',
      },
      {
        id: 3,
        title: 'Dúper Mario Bros - Teaser #3',
        thumbnailUrl: DMBT3,
        webUrl: 'https://www.youtube.com/embed/bgy4rxW8YEA', // Add the episode URL
        backgroundImage: DMBPT3,
        seriesLogo: DMBLogo,
        description: 'Mario y los demás se preparan para su siguiente reto. No se pierdan este año LA OTRA PARTE DE Dúper Mario Bros - Episodio 12...',
      },
      {
        id: 4,
        section: 'Trailers',
        title: 'Trailer - LA OTRA PARTE DE Dúper Mario Bros - Episodio 12',
        thumbnailUrl: DMB12T,
        webUrl: 'https://www.youtube.com/embed/_diKznt3v34', // Add the episode URL
        backgroundImage: DMB12TP,
        seriesLogo: DMBLogo,
        description: 'Proximemente',
      },
      
      {
        id: 5,
        section: 'Trailers',
        title: 'Dúper Mario Bros - Episodio 13 || Trailer',
        thumbnailUrl: DMB13T,
        webUrl: 'https://www.youtube.com/embed/q8H8WdX04tM', // Add the episode URL
        backgroundImage: DMB13TP,
        seriesLogo: DMBLogo,
        description: 'Proximemente',
      },

      {
        id: 3,
        section: 'Extra',
        title: '¿Qué pasó con TheMarioDimension2',
        thumbnailUrl: QPTMD2,
        webUrl: 'https://www.youtube.com/embed/0gcJCRUKAYcqIYzv', // Add the episode URL
        backgroundImage: QPTMD2,
        seriesLogo: TMDLOGO,
        description: 'Gracias a los que me apoyaron este año. Vamos a tratar de recuperar un poco de lo perdido. Cualquier novedad o información se las compartiré por aquí.',
      },
      {
        id: 4,
        section: 'Extra',
        title: 'El Regreso',
        thumbnailUrl: REGRESO,
        webUrl: 'https://www.youtube.com/embed/0gcJCRUKAYcqIYzv', // Add the episode URL
        backgroundImage: REGRESO,
        seriesLogo: TMDLOGO,
        description: 'Hora del comeback! No se pierdan cual es el plan para regresar y mejor que nunca...',
      },
      */
      {
        id: 8,
        section: 'PD',
        title: 'Preguntas Dimensionales #8 || El Adios de Ezlo',
        thumbnailUrl: PD8,
        webUrl: 'https://www.youtube.com/embed/hqdeVZ3IZO8', // Add the episode URL
        backgroundImage: PDP8,
        seriesLogo: PDLogo,
        description: 'Link y Ezlo regresan a darnos las respuestas a todas sus preguntas! Solo que en esta ocasión, Ezlo tiene una noticia muy importante que compartir.',
      },
      {
        id: 16,
        section: 'DMB',
        title: 'Episodio 13 : La Torre Sagrada',
        thumbnailUrl: DMB13,
        webUrl: 'https://www.youtube.com/embed/q8H8WdX04tM', // Add the episode URL
        backgroundImage: DMBP13,
        seriesLogo: DMBLogo,
        description: '¡Johnny está en peligro! Separado del grupo, Toad tropieza con una persona familiar. Mientras tanto, los errores del pasado asechan a Mario, y nuestros heroes se enfrentan a un dilema que pondrá a prueba su lealtad. ¿Hasta dónde están dispuestos a llegar por las esferas sagradas?',
      },
      /*
      {
        id: 8,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #7',
        thumbnailUrl: PD7T,
        webUrl: 'https://www.youtube.com/embed/lTcgm2u0dDk', // Add the episode URL
        backgroundImage: PD7TP,
        seriesLogo: PDLogo,
        description: 'Si ves esto eres cool.',
      },
      {
        id: 9,
        section: 'Lost',
        title: 'EL REGRESO || PROXIMAMENTE',
        thumbnailUrl: ENTRETT,
        webUrl: 'https://www.youtube.com/embed/ylEsY96JSug', // Add the episode URL
        backgroundImage: ENTRETT,
        seriesLogo: TMDLOGO,
        description: 'Rodrigo regresa a contarnos su versión. Desde sus inicios en YouTube, hasta lo que ha estado haciendo estos últimos años. Esperen la entrevista proximamente!! Esto se logró gracias a todos ustedes!!',
      },
      {
        id: 10,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #8',
        thumbnailUrl: PD8T,
        webUrl: 'https://www.youtube.com/embed/ky46r3O4BGM', // Add the episode URL
        backgroundImage: PD8T,
        seriesLogo: PDLogo,
        description: 'Si lees esto eres chido.',
      },
      {
        id: 11,
        section: 'Lost',
        title: 'Trailer Jueguemos a...',
        thumbnailUrl: JATR,
        webUrl: 'https://www.youtube.com/embed/-ILKPBGIeFE', // Add the episode URL
        backgroundImage: JATR,
        seriesLogo: JALogo,
        description: 'Si ves esto escribe "pollo" en los comentarios...',
      },
      {
        id: 12,
        section: 'Lost',
        title: 'Teaser - ¿Te Parece Divertido?',
        thumbnailUrl: LBTPDT2,
        webUrl: 'https://www.youtube.com/embed/Qm45_7HChKM', // Add the episode URL
        backgroundImage: LBTPDT2,
        seriesLogo: CreepyLogo,
        description: 'Algo aterrador se acerca...',
      },
      {
        id: 2,
        section: 'Lost',
        title: '29 de Febrero...wiiiii!',
        thumbnailUrl: DOM,
        webUrl: 'https://www.youtube.com/embed/Ety6CbFc8g0', // Add the episode URL
        backgroundImage: DOM,
        seriesLogo: TMDLOGO,
        description: 'Veamos si mi cuenta dura para el 29 de Febrero de 2016! :D',
      },
      
     
      {
        id: 9,
        section: 'Extra',
        title: 'dúper mario',
        thumbnailUrl: DMBR,
        webUrl: 'https://www.youtube.com/embed/mFPcrhUzaBU', // Add the episode URL
        backgroundImage: DMBR,
        seriesLogo: TMDLOGO,
        description: '',
      },
      */
      {
        id: 10,
        section: 'Extra',
        title: 'TheMarioDimension',
        thumbnailUrl: TMDT,
        webUrl: 'https://www.youtube.com/embed/Z1p8sNJfG1g', // Add the episode URL
        backgroundImage: TMDT,
        seriesLogo: TMDLOGO,
        description: 'Hey:)',
      },
      {
        id: 11,
        section: 'Extra',
        title: 'Proyectos y Animaciones de TheMarioDimension que nunca salieron',
        thumbnailUrl: PCA,
        webUrl: 'https://www.youtube.com/embed/k8_VZUUEIlg', // Add the episode URL
        backgroundImage: PCA,
        seriesLogo: TMDLOGO,
        description: 'Hola amigos:) el día de hoy les quiero compartir algunos trabajos y material del pasado que encontré entre mis archivos y que nunca llegué a terminar o siquiera sacar a la luz.',
      },
      {
        id: 8,
        section: 'Extra',
        title: 'El Regreso de TheMarioDimension - Entrevista Completa',
        thumbnailUrl: ENTRET,
        webUrl: 'https://www.youtube.com/embed/zrxr8-TJXP0', // Add the episode URL
        backgroundImage: ENTREP,
        seriesLogo: TMDLOGO,
        description: 'El regreso de TheMarioDimension. Despues de 11 años, Rodrigo regresa a platicarnos no solo de su estado actual, sino tambien de su trayectoria en YouTube.',
      },
      
];

export default episodes;

